import {BaseFilter} from './base.filter';

export class ResidentApplicationFilter extends BaseFilter {
    locationId: string;
    searchTerm: string;
    gender: any;
}
